import React, { Component } from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
const platforms = [{
  id: 'Instagram',
  label: 'Instagram',
  icon: InstagramIcon,
  activeClass: 'bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white shadow-md',
  inactiveClass: 'bg-pink-50 text-pink-600 hover:bg-pink-100 border border-pink-200'
}, {
  id: 'Facebook',
  label: 'Facebook',
  icon: FacebookIcon,
  activeClass: 'bg-[#1877F2] text-white shadow-md',
  inactiveClass: 'bg-blue-50 text-blue-600 hover:bg-blue-100 border border-blue-200'
}, {
  id: 'LinkedIn',
  label: 'LinkedIn',
  icon: LinkedinIcon,
  activeClass: 'bg-[#0A66C2] text-white shadow-md',
  inactiveClass: 'bg-sky-50 text-sky-700 hover:bg-sky-100 border border-sky-200'
}, {
  id: 'TikTok',
  label: 'TikTok',
  icon: null,
  activeClass: 'bg-black text-white shadow-md',
  inactiveClass: 'bg-slate-100 text-slate-800 hover:bg-slate-200 border border-slate-200'
}];
interface PlatformSelectorProps {
  activePlatform: string;
  setActivePlatform: (platform: string) => void;
}
export function PlatformSelector({
  activePlatform,
  setActivePlatform
}: PlatformSelectorProps) {
  return <div className="flex flex-wrap gap-2" data-id="element-106">
      {platforms.map(platform => {
      const isActive = activePlatform === platform.id;
      const IconComponent = platform.icon;
      return <button key={platform.id} onClick={() => setActivePlatform(platform.id)} className={`flex items-center gap-2 px-5 py-2.5 rounded-xl text-sm font-semibold transition-all ${isActive ? platform.activeClass : platform.inactiveClass}`} data-id="element-107">
            {IconComponent && <IconComponent className="w-4 h-4" data-id="element-108" />}
            {platform.id === 'TikTok' && <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" data-id="element-109">
                <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.18 8.18 0 0 0 4.76 1.52V6.84a4.83 4.83 0 0 1-1-.15z" data-id="element-110" />
              </svg>}
            {platform.label}
          </button>;
    })}
    </div>;
}